import {canEditTeamProfile} from '../utils/teamRolePermissions';
export const THEME_VERSION = 1;
export const TEAM_THEME_PRESETS = {
  ocean: {name:'Ocean', primary:'#1266b5', supporting:'#74c7ec', background:'#102f50'},
  violet: {name:'Violet', primary:'#7541b5', supporting:'#c3a6ef', background:'#26183d'},
  forest: {name:'Forest', primary:'#26734d', supporting:'#8cd4ad', background:'#142d24'},
  ember: {name:'Ember', primary:'#b64722', supporting:'#ffb18d', background:'#38241e'},
};
export const DEFAULT_CUSTOM_COLORS = {primary:'#159db5', supporting:'#94d5e0', background:'#0e131b'};
export function normalizeTeamAppearance(value) {
  if (!value || value.version !== THEME_VERSION || !['default','preset','custom'].includes(value.mode)) return null;
  if (value.mode === 'default') return {version:1,mode:'default'};
  if (value.mode === 'preset') return TEAM_THEME_PRESETS[value.preset] ? {version:1,mode:'preset',preset:value.preset} : null;
  if (!value.colors || !['primary','supporting','background'].every(key => /^#[\da-f]{6}$/i.test(value.colors[key]))) return null;
  return {version:1,mode:'custom',colors:Object.fromEntries(['primary','supporting','background'].map(key=>[key,value.colors[key].toLowerCase()]))};
}
export function contrastRatio(a,b) {
  const luminance = hex => {
    const c=hex.slice(1).match(/../g).map(x=>parseInt(x,16)/255).map(x=>x<=.04045?x/12.92:((x+.055)/1.055)**2.4);
    return c[0]*.2126+c[1]*.7152+c[2]*.0722;
  };
  const x=luminance(a),y=luminance(b);return (Math.max(x,y)+.05)/(Math.min(x,y)+.05);
}
function blend(a,b,amount) {
  const bytes = hex => hex.slice(1).match(/../g).map(x=>parseInt(x,16));
  const x=bytes(a),y=bytes(b);return '#'+x.map((n,i)=>Math.round(n*(1-amount)+y[i]*amount).toString(16).padStart(2,'0')).join('');
}
function readable(color,background) {
  if (contrastRatio(color,background)>=4.5) return color;
  const target=contrastRatio('#ffffff',background)>contrastRatio('#000000',background)?'#ffffff':'#000000';
  for(let i=1;i<=20;i++){const adjusted=blend(color,target,i/20);if(contrastRatio(adjusted,background)>=4.5)return adjusted;}
  return target;
}
export function generateTeamTheme(settings,mode='dark') {
  const normalized=normalizeTeamAppearance(settings);
  if(!normalized || normalized.mode==='default')return null;
  const colors=normalized.mode==='preset'?TEAM_THEME_PRESETS[normalized.preset]:normalized.colors;
  const darkPage=blend(colors.background,'#000000',.7);
  const darkCard=blend(darkPage,'#ffffff',.08);
  const lightPage=blend(colors.background,'#ffffff',.97);
  const lightCard=blend(colors.background,'#ffffff',.93);
  const darkAccent=readable(colors.supporting,darkCard);
  const lightAccent=readable(colors.primary,lightPage);
  const action=readable(colors.primary,'#ffffff');
  return {
    colors:{accent:mode==='light'?blend(darkAccent,'#000000',.08):darkAccent,pale:blend(colors.supporting,'#ffffff',.7),primary:action,secondary:blend(lightAccent,'#000000',.18)},
    surfaces:{darkPage,darkCard,darkElevated:blend(darkPage,'#ffffff',.14),lightPage,lightCard},
    adjusted:action!==colors.primary || darkAccent!==colors.supporting || lightAccent!==colors.primary,
  };
}
export function canEditTeamAppearance(team,uid) { return canEditTeamProfile(team,uid); }
